<template>
  <li
    v-on:click="activate"
    v-bind:class="{ active: isActive, inactive: isInactive }"
    v-wave="{color: '#54a324',initialOpacity: 0.3,easing: 'ease-in'}"
  >
    {{ name }}
  </li>
</template>

<script>
export default {
  name: "ConfiguratorStepListItem",
  props: ["option", "item"],
  data: function() {
    return {};
  },
  computed: {
    name: function() {
      return this.item.name;
    },
    isActive: function() {
      return this.$store.state.selected[this.option] == this.item.id;
    },
    isInactive: function() {
      return (
        this.isActive == false &&
        this.$store.state.selected[this.option] !== null
      );
    }
  },
  methods: {
    activate: function() {
      this.$store.dispatch("selectOption", {
        name: this.option,
        value: this.item.id
      });
    }
  }
};
</script>

<style scoped>
li {
  padding: 7px 30px;
  margin: 0 5px;
  font-size: 16px;
  line-height: 20px;
  cursor: pointer;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

li:hover {
  background: #eee;
}

li.inactive {
  color: #888;
}

li.active {
  color: #54a324;
}

li.active:after {
  content: "\E5CA";
  font-family: "Material Icons";
  font-size: 16px;
  line-height: 32px;
  position: absolute;
  left: 5px;
  top: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/ConfiguratorStepListItem.vue